import _ from 'lodash'

export const getSelectedGroups = (state) =>
    state
        .getIn(['ui', 'entityStack', 'groupState', 'ids'])
        .map((id) =>
            state
                .getIn(['ui', 'entityStack', 'groups', 'groups'])
                .find((entity) => _.toString(entity.get('entId')) === _.toString(id))
        )

export const getSelectedHistory = (state) =>
    state
        .getIn(['ui', 'entityStack', 'historyState', 'ids'])
        .map((id) =>
            state.getIn(['ui', 'entityStack', 'history', 'entities']).find((entity) => entity.get('entId') === id)
        )

export const getSelectedFavourites = (state) =>
    state
        .getIn(['ui', 'entityStack', 'favouriteState', 'ids'])
        .map((id) =>
            state
                .getIn(['ui', 'entityStack', 'favourites', 'entities'])
                .find((entity) => _.toString(entity.get('entId')) === _.toString(id))
        )

export const shouldUpdateEntityStack = (props, nextProps) => {
    const { activeTab, hasRibbon, ribbonOpen, visibleEntityStack, activeGroupId, notifications } = props
    const {
        activeTab: nextActiveTab,
        ribbonOpen: nextRibbonOpen,
        visibleEntityStack: nextVisibleEntityStack,
        hasRibbon: nextHasRibbon,
        activeGroupId: nextActiveGroupId,
        notifications: nextNotifications,
    } = nextProps
    return (
        activeTab !== nextActiveTab ||
        ribbonOpen !== nextRibbonOpen ||
        visibleEntityStack !== nextVisibleEntityStack ||
        hasRibbon !== nextHasRibbon ||
        activeGroupId !== nextActiveGroupId ||
        !_.isEqual(notifications, nextNotifications)
    )
}
